export const MARKETPLACE_DISCOUNT_MODAL_ID = 'marketplace-discount-modal'
export const MARKETPLACE_DISCOUNT_MODAL_CONTAINER_ID =
  'marketplace-discount-modal-container'
